import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import clsx from 'clsx';
import {
    Avatar,
    Box,
    Button
} from '@material-ui/core';
import {Initials} from '../../../vendors/utils/common'
import {ClipLoader} from "react-spinners";
import {setActiveLink, setSidebarToggleMobile} from "../../../vendors/actions/layout";

interface OwnProps {

}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    setSidebarToggle?: (data: any) => void;
    setSidebarToggleMobile?: (data: any) => void;
    setActiveLink?: (data: string) => void
}

const SidebarUserBox = (props: any) => {
    const {sidebarToggle, sidebarHover, avatarLoading, sidebarToggleMobile} = props.Layout;
    const {User, setActiveLink, setSidebarToggleMobile} = props;

    const navigate = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setSidebarToggleMobile(!sidebarToggleMobile);
        return props.history.push('/profile')
    };

    return (
        <Fragment>
            <Box className={clsx('app-sidebar-userbox mb-4', {
                    'app-sidebar-userbox--collapsed': sidebarToggle && !sidebarHover
                })}>
                <Avatar
                    alt={`${User.first_name} ${User.last_name}`}
                    src={!avatarLoading ? User.avatar : ''}
                    className="app-sidebar-userbox-avatar"
                >
                    {avatarLoading ? (<ClipLoader color={'var(--primary)'}
                                                  loading={true}/>) : Initials(`${User.first_name || ''} ${User.last_name || ''}`)}
                </Avatar>
                <Box className="app-sidebar-userbox-name">
                    <Box className={clsx('app-sidebar-user-name', {
                        'pb-2': User.business_name
                    })}>
                        {User.first_name} {User.last_name}
                    </Box>
                    {<Box className='app-sidebar-user-business'>{User.business_name}</Box>}
                    <Box className="app-sidebar-userbox-btn-profile">
                        <Button
                            onClick={(e) => {navigate(e); setActiveLink('/profile')}}
                            size="small"
                            color="secondary"
                            variant="contained"
                            className="text-white text-transform-none profile-btn-link"
                            href="/profile">
                            View Profile
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout} = state;
    return {User, Layout}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setActiveLink: (data: string) => dispatch(setActiveLink(data)),
        setSidebarToggleMobile: (data: any) => dispatch(setSidebarToggleMobile(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarUserBox);
